<template>
  <li @click="emit('click')">
    <span class="material-symbols-outlined">
      {{ props.icon }}
    </span>
    <span>{{ props.label }}</span>
  </li>
</template>

<script lang="ts" setup>
const emit = defineEmits(['click']);
const props = defineProps<{
  label: string;
  icon: string;
}>();
</script>

<style lang="scss" scoped>
li {
  font-weight: bold;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  &:hover,
  &:focus,
  &:active {
    color: var(--bs-primary);
  }
}
</style>
